import {
  CirclePlus,
  ShieldCheck,
  Shield,
  Armchair,
  PackageOpen,
  Star,
  Fuel,
  Wrench,
  Smile,
  Palette,
} from "lucide-react";

const NOTES = [
  { label: "Sécurité", name: "security_note", Icon: Shield },
  { label: "Confort", name: "comfort_note", Icon: Armchair },
  { label: "Habitabilité", name: "capacity_note", Icon: PackageOpen },
  { label: "Qualité", name: "quality_note", Icon: Star },
  { label: "Consommation", name: "consumption_note", Icon: Fuel },
  { label: "Coût de maintenance", name: "maintenance_cost_note", Icon: Wrench },
  { label: "Plaisir de conduite", name: "fun_note", Icon: Smile },
  { label: "Équipement", name: "equipment_note", Icon: CirclePlus },
  { label: "Fiabilité", name: "reliability_note", Icon: ShieldCheck },
  { label: "Design", name: "design_note", Icon: Palette },
];

export const reviewNotes = NOTES.map((note) => ({
  ...note,
  icon: <note.Icon className="size-6" />,
}));

export type NoteTone = "good" | "medium" | "bad";

export const noteTone = (note: number): NoteTone => {
  if (note >= 8) return "good";
  if (note >= 6) return "medium";
  return "bad";
};

const NOTE_BACKGROUNDS: Record<NoteTone, string> = {
  good: "bg-green-500",
  medium: "bg-yellow-500",
  bad: "bg-red-500",
};

export const colorForNote = (note: number) => NOTE_BACKGROUNDS[noteTone(note)];
